export const INSURERS = "payers"; // the backend expects payers
export const INSURER_NAME = "name";
export const INSURER_DETAILS = "insuranceDetails";
export const INSURER_DETAILS_NAME = "name";
export const MEMBERSHIP_NUMBER = "insuranceNumber";
export const NATIONAL_ID_NUMBER = "nationalIdNumber";
export const DEPENDENT = "dependent";
export const MEMBER = "MEMBER";
export const SPOUSE = "SPOUSE";
export const CHILD = "CHILD";
export const DEPENDENTSPOUSE = "DEPENDENTSPOUSE";
export const DEPENDENTCHILD = "DEPENDENTCHILD";
export const PATIENT = "PATIENT";
export const INSURER = "INSURER";
export const INSURER_TYPE = "type";
export const BALANCE = "balance";
export const TOTAL = "total";
export const NHIF = "NHIF";
export const PRIVATE_INSURANCE = "Private";
export const PROPERTIES = "properties";
export const LINDA_MAMA_ID = "LM";
